<script>
import { mapState } from 'vuex'
import MemberForm from '@src/forms/Member'
import Request from '@src/mixins/request'

export default {
  $_veeValidate: { validator: 'new' },

  mixins: [Request],

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      color: 'gold',
      form: new MemberForm(),
    }
  },

  computed: {
    ...mapState('app', {
      propertyId: (state) => state.currentProperty.id,
    }),
    dialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    countries() {
      return this.$route.params.countries
    },
    titles() {
      return this.$route.params.titles
    },
    schema() {
      return MemberForm.validator(this.titles, this.countries)
    },
  },

  watch: {
    dialog(val) {
      if (!val) {
        setTimeout(() => {
          this.form = new MemberForm()
        }, 300)
      }
      this.errors.clear()
    },
  },

  methods: {
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.createMember()
        }
      })
    },
    createMember() {
      this.updateData({
        url: this.endpoint.member.add,
        data: {
          propertyId: this.propertyId,
          data: this.form,
        },
      }).then(() => {
        this.dialog = false
        this.$emit('member-added')
      })
    },
  },
}
</script>

<template>
  <VDialog v-model="dialog" max-width="640px" persistent>
    <VCard>
      <VCardText>
        <VLayout row wrap>
          <VFlex xs12>
            <div class="title mb-2">New Member</div>

            <BaseControlInput label="Title">
              <VAutocomplete
                v-model="form.title"
                v-validate="schema.title"
                data-vv-name="tite"
                label="Title"
                :error-messages="errors.collect('tite')"
                :color="color"
                :items="titles"
              />
            </BaseControlInput>

            <BaseControlInput label="First name">
              <VTextField
                v-model="form.firstName"
                v-validate="schema.name"
                data-vv-name="first name"
                label="First name"
                :error-messages="errors.collect('first name')"
                :color="color"
              />
            </BaseControlInput>

            <BaseControlInput label="Last name">
              <VTextField
                v-model="form.lastName"
                v-validate="schema.name"
                data-vv-name="last name"
                label="Last name"
                :error-messages="errors.collect('last name')"
                :color="color"
              />
            </BaseControlInput>

            <BaseControlInput label="Email">
              <VTextField
                v-model="form.email"
                v-validate="schema.email"
                data-vv-name="email"
                label="Email"
                :error-messages="errors.collect('email')"
                :color="color"
              />
            </BaseControlInput>

            <BaseControlInput label="Country">
              <VAutocomplete
                v-model="form.country"
                v-validate="schema.country"
                data-vv-name="country"
                label="Country"
                :error-messages="errors.collect('country')"
                :color="color"
                :items="countries"
                item-text="name"
                item-value="id"
              />
            </BaseControlInput>
          </VFlex>
        </VLayout>
      </VCardText>

      <VCardActions>
        <VSpacer />
        <VBtn depressed @click="dialog = false">
          Close
        </VBtn>
        <VBtn depressed dark :color="color" @click="submitForm">
          Save
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>
